import { useEffect, useRef } from "react";

export default function useClickSound() {
    const audioRef = useRef(null);

    useEffect(() => {
        // 🔊 Create audio only ONCE (important for mobile)
        audioRef.current = new Audio("/sounds/click.mp3");
        audioRef.current.volume = 0.2; // soft premium click

        /* =====================================================
           OPTIONAL FEATURE: stop sound when tab/app is hidden
           (IMPORTANT for mobile background / app switch)
        ====================================================== */
        const handleVisibilityChange = () => {
            if (document.hidden && audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            // 🛑 CLEANUP: stop sound when component unmounts
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
            /* =====================================================

            You can comment this block if you ever want sound to continue.

            ====================================================== */

            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    /* =====================================================
       PLAY SOUND FUNCTION
       Call this ONLY where sound is needed (logo click)
    ====================================================== */
    const playSound = () => {
        if (!audioRef.current) return;

        // Restart sound from beginning every time
        audioRef.current.currentTime = 0;

        audioRef.current.play().catch(() => {
            // Browser blocked autoplay — ignore safely
        });
    };

    return playSound;
}
